import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { BaseMaterial } from '../models'

export const url = '/libraries/management/types/baseMaterial/entries'
export interface BaseMaterialItem extends BaseMaterial {
    new?: boolean
}
@Injectable({
    providedIn: 'root'
})
export class BaseMaterialService {
    constructor(private http: HttpService) {}

    getAll(): Observable<BaseMaterialItem[]> {
        return this.http.get(url)
    }

    remove(data: BaseMaterialItem[]): Observable<boolean> {
        return this.http.delete(url, { data })
    }

    create(data: BaseMaterialItem[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: BaseMaterialItem[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
